import { ReactNode } from 'react';
import './ChartContainerFooter.scss';

interface ChartContainerFooterProps {
  content: string | string[] | ReactNode;
}

export const ChartContainerFooter = ({ content }: ChartContainerFooterProps) => {
  const resolvedContent = Array.isArray(content)
    ? content.map((str, i) => <span key={i}>{str}</span>)
    : content;
  return (
    <div className='chart-container-footer-container'>
      <div className='chart-container-footer'>{resolvedContent}</div>
    </div>
  );
};
